import { Button, ListItem, MenuOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PersonGroup, PersonRemove } from '@fs/zion-icon'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'

/**
 * ManageIndexesButton
 *
 * Renders a button with a dropdown menu overlay containing options to manage indexing operations:
 * - Delete persons
 * - Edit households
 *
 * @component
 * @returns {JSX.Element}
 */
const ManageIndexesButton = () => {
  const [t] = useTranslation()
  const { openOverlay } = useOverlayContext()

  const handleManageNames = () => {
    openOverlay('manageNamesPanel')
  }

  return (
    <MenuOverlay
      menuButton={
        <Button emphasis="low" data-testid="manage-indexes-button" linkName="Manage Indexes">
          {t('manage-indexes-button.label', 'Manage Indexes')}
        </Button>
      }
      aria-label={t('manage-indexes-button.label', 'Manage Indexes')}
    >
      <ListItem
        primaryText={t('manage-indexes-button.delete', 'Delete')}
        startElement={<ListItem.Icon Icon={PersonRemove} />}
        onClick={() => openOverlay('removePerson')}
      />
      <ListItem
        primaryText={t('manage-indexes-button.edit-households', 'Edit Households')}
        startElement={<ListItem.Icon Icon={PersonGroup} />}
        onClick={handleManageNames}
      />
    </MenuOverlay>
  )
}

export default ManageIndexesButton
